import { i18n } from "@lingui/core";
import { messages as en } from "../locales/en/messages";
import { messages as es } from "../locales/es/messages";

// 1. Ładujemy wszystko od razu
i18n.load({
  en: en,
  es: es
});

// 2. Pobieramy język z localStorage ZANIM React wystartuje
const savedLocale = localStorage.getItem("lang") || "en";

// 3. Aktywujemy go natychmiast
i18n.activate(savedLocale);

export function loadMessages(locale) {
  console.log(`[i18n] Zmiana ręczna na: ${locale}`);
  i18n.activate(locale);
}

export { i18n };

